export default {

    title: "Caricamento...",

    responses: {
        "404": {
            title: "Si è verificato un errore",
            header: "Si è verificato un errore",
            message: "Token non valido trovato. Il tuo token potrebbe essere scaduto."
        },
        "200_tfalogin": {
            title: "Verifica dell'accesso",
            header: "@:views.tunnel.service.response.200_tfalogin.title",
            message: "L'accesso è stato verificato."
        },
        "404_tfalogin": {
            title: "Verifica dell'accesso",
            header: "@:views.tunnel.service.response.404_tfalogin.title",
            message: "Token non valido trovato. Il tuo token potrebbe essere scaduto."
        },
        "200_tfaaddress": {
            title: "Verifica dell'indirizzo",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Grazie per aver verificato il tuo indirizzo. Ora puoi selezionarlo come indirizzo di spedizione al momento dell'ordine."
        },
        "404_tfaaddress": {
            title: "Verifica dell'indirizzo",
            header: "@:views.tunnel.service.response.404_tfaaddress.title",
            message: "Token non valido trovato. Il tuo token potrebbe essere scaduto."
        },
        "201_delivery": {
            title: "Grazie",
            header: "Grazie",
            message: "Grazie per la sua risposta."
        },
        "201_shipment_received": {
            title: "Grazie",
            header: "Grazie",
            message: "Grazie per la sua risposta."
        },
        "400": {
            title: "Richiesta non valida. Si è verificato un errore.",
            header: "@:views.tunnel.service.response.400.title",
            message: "Richiesta non valida. Si è verificato un errore."
        }
    }
}